import {WipLevelDocSchemaV2} from "@repo/shared";

import {functionHookFactory} from "../factories/functionHookFactory";

export const useSubmitLevelV2 = functionHookFactory(
  "submitLevelV2",
  WipLevelDocSchemaV2,
);
